const STATUS_LABELS = {
  trial: "Пробний період",
  active: "Активна",
  past_due: "Прострочена оплата",
  cancelled: "Скасовано (до кінця періоду)",
  expired: "Закінчилась",
};

const PAYMENT_STATUS_CLASS = {
  success: "pay-status--paid",
  pending: "pay-status--pending",
  failed: "pay-status--failed",
  refunded: "pay-status--failed",
};

const PAYMENT_STATUS_LABEL = {
  success: "Оплачено",
  pending: "Очікує",
  failed: "Невдало",
  refunded: "Повернено",
};

export function subscriptionStatusLabel(status) {
  return STATUS_LABELS[status] || status;
}

export function paymentStatusClass(status) {
  return PAYMENT_STATUS_CLASS[status] || "pay-status--pending";
}

export function paymentStatusLabel(status) {
  return PAYMENT_STATUS_LABEL[status] || status;
}

export function billingIntervalLabel(interval) {
  if (interval === "yearly") return "рік";
  if (interval === "monthly") return "місяць";
  return interval;
}

export function formatMoney(amount, currency) {
  const value = Number(amount);
  if (Number.isNaN(value)) return `${amount} ${currency}`;
  return `${value.toLocaleString("uk-UA")} ${currency}`;
}

export function formatPeriodEnd(isoDate) {
  if (!isoDate) return "—";
  try {
    return new Date(isoDate).toLocaleDateString("uk-UA", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  } catch (_err) {
    return isoDate;
  }
}
